import { render, staticRenderFns } from "./WamSelect.vue?vue&type=template&id=0f56ad1d&lang=pug"
import script from "./WamSelect.vue?vue&type=script&lang=js"
export * from "./WamSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports